import { create } from 'zustand';

export const useToastStore = create((set) => ({
    toastProps: null,

    showToast: (message, type = 'error') => {
        const toastProps = {
            id: Date.now(),
            message,
            color: type === 'error' ? 'danger' : 'warning',
            icon: 'error_outline_icon',
            border: 'left',
            dismissTime: 5000, // auto-close after 5 sec.
        };
        set({ toastProps });
    },

    clearToast: () => set({ toastProps: null }),
}));
